import { WorkSession } from "entities/workSession";
import Project_Entity from "./project";
import moment from "moment";
export default class Project extends Project_Entity {
  static fromList(projectsJSON: unknown): Array<Project> {
    const projects: Project[] = [];
    if (projectsJSON)
      Array.isArray(projectsJSON) &&
        projectsJSON.forEach((projectJSON) => {
          projects.push(new Project(projectJSON));
        });
    return projects;
  }

  from(ws: WorkSession[]) {
    const workSessions = ws.filter(
      (w) => w.projectID === this.id && moment(w.dateFromUTC).year() > 1
    );

    const firstWorkSession = workSessions?.length ? workSessions[0] : undefined;
    if (firstWorkSession) return firstWorkSession?.dateFromUTC;

    return undefined;
  }

  to(ws: WorkSession[]) {
    const workSessions = ws.filter(
      (w) => w.projectID === this.id && moment(w.dateToUTC).year() > 1
    );

    const lastWorkSession = workSessions?.length
      ? workSessions[workSessions.length - 1]
      : undefined;
    return lastWorkSession?.dateToUTC;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
